import { Component } from "react";
import "./Experience.css";
import "./ExperienceMobile.css";
import Analytics from "../../utils/analytics";
import { flattenedExperiences } from "../../data/experiences";

class Experience extends Component {
  experiences = flattenedExperiences;

  constructor(props) {
    super();
    this.state = {
      isMobile: props.isMobile,
      selectedExperience: this.experiences[0],
    };
  }

  selectExperience = (experience) => {
    this.setState({ selectedExperience: experience });
    Analytics.trackExperienceClick(experience.company);
  };

  render() {
    if (this.state.isMobile()) {
      return (
        <div className="main-experience-mobile">
          <div className="main-experience-box-mobile">
            <div className="main-experience-banner-mobile">
              {this.experiences.map((experience) => (
                <div
                  className={`main-experience-banner-company-name-mobile ${
                    experience.company === this.state.selectedExperience.company &&
                    experience.position === this.state.selectedExperience.position
                      ? "active"
                      : ""
                  }`}
                  onClick={() => this.selectExperience(experience)}
                  key={`${experience.company} ${experience.position}`}
                >
                  <p className="main-experience-banner-company-name-title-mobile">
                    {experience.company}
                  </p>
                </div>
              ))}
            </div>
            <div className="main-experience-banner-info-mobile">
              <div className="main-experience-banner-info-position-mobile">
                <p className="main-experience-banner-info-position-title-mobile">
                  {this.state.selectedExperience.position}
                  <span style={{ fontSize: '0.9rem', color: '#888', marginLeft: 8 }}>
                    {this.state.selectedExperience.from} - {this.state.selectedExperience.to}
                  </span>
                </p>
              </div>
              <ul className="main-experience-banner-info-list-mobile">
                {this.state.selectedExperience.highlights.map((info) => (
                  <li
                    className="main-experience-banner-info-detail-mobile"
                    key={info}
                  >
                    {info}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="main-experience home-section">
          <div className="main-experience-box">
            <div className="main-experience-banner">
              {this.experiences.map((experience) => (
                <div
                  className={`main-experience-banner-company-name ${
                    experience.company === this.state.selectedExperience.company &&
                    experience.position === this.state.selectedExperience.position
                      ? "active"
                      : ""
                  }`}
                  onClick={() => this.selectExperience(experience)}
                  key={`${experience.company} ${experience.position}`}
                >
                  <p className="main-experience-banner-company-name-title">
                    {experience.company}
                  </p>
                </div>
              ))}
            </div>
            <div className="main-experience-banner-info">
              <div className="main-experience-banner-info-position">
                <p className="main-experience-banner-info-position-title">
                  {this.state.selectedExperience.position}
                  <span style={{ fontSize: '1rem', color: '#888', marginLeft: 12 }}>
                    {this.state.selectedExperience.from} - {this.state.selectedExperience.to}
                  </span>
                </p>
              </div>
              <ul className="main-experience-banner-info-list">
                {this.state.selectedExperience.highlights.map((info) => (
                  <li
                    className="main-experience-banner-info-detail"
                    key={info}
                  >
                    {info}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Experience;
